import { rowsHaveSameContent } from './rowsHaveSameContent';

const reconcilePersistedRowsToAdd = (state, incomingClonedRowData, getUniqueRowId) => {
  if (!state.rowsToAdd.length) {
    return state.rowsToAdd;
  }

  const previousRowIds = new Set(
    state.clonedRowData
      .map(row => getUniqueRowId({ data: row }))
      .filter(rowId => rowId != null && rowId !== ''),
  );

  const newlyPersistedRows = incomingClonedRowData.filter(row => {
    const rowId = getUniqueRowId({ data: row });

    return rowId != null && rowId !== '' && !previousRowIds.has(rowId);
  });

  if (!newlyPersistedRows.length) {
    return state.rowsToAdd;
  }

  return state.rowsToAdd.filter(
    pendingRow =>
      !newlyPersistedRows.some(serverRow =>
        rowsHaveSameContent(pendingRow, serverRow, getUniqueRowId),
      ),
  );
};

export default reconcilePersistedRowsToAdd;
